<template>
    <div class="card-header-block">
        <el-radio-group v-model="type" size="mini" @change="changeType">
            <el-radio-button :label="1">人流量</el-radio-button>
            <el-radio-button :label="2">在场人数</el-radio-button>
            <el-radio-button :label="3">人流密度</el-radio-button>
            <el-radio-button :label="4">停留时间</el-radio-button>
        </el-radio-group>
    </div>
</template>
<script>
export default {
    name: "SelectChartValueType",
    data() {
        return {
            type: "1",
        };
    },
    methods: {
        changeType() {
            this.$emit("change", this.type);
        },
    },
};
</script>
